const selector = {
    oldPasswordVisibility: '#oldPasswordVisibility',
    oldPassword: '#old_password',
    newPasswordVisibility: '#newPasswordVisibility',
    newPassword: '#new_password',
    newPasswordConfirmVisibility: '#newPasswordConfirmVisibility',
    newPasswordConfirm: '#new_password_confirmation',
};

export {selector};